/**
 * Displays a full-page flash banner using the server-rendered `.js-flash-template`.
 */
export async function displayFlashMessage(type: 'success' | 'error', message: string) {
  const {TemplateInstance} = await import('@github/template-parts')
  const template = document.querySelector<HTMLTemplateElement>('template.js-flash-template')
  const flashContainer = document.querySelector<HTMLElement>('#js-flash-container')
  if (!template || !flashContainer) return

  const instance = new TemplateInstance(template, {
    className: type === 'success' ? 'flash-success' : 'flash-error',
    message,
  })
  const node = document.importNode(instance, true)
  for (const child of [...flashContainer.children]) {
    if (!child.classList.contains('js-flash-template')) {
      flashContainer.removeChild(child)
    }
  }
  flashContainer.appendChild(node)
}
